export default function AlternativeSectionLabel({ label, number }: { label: string; number?: string }) {
  return (
    <div className="mb-6 flex items-center justify-center gap-3 font-mono text-[11px] font-semibold uppercase leading-5 tracking-widest text-grey-200 sm:gap-4 sm:text-xs">
      <span aria-hidden="true" className="h-px w-24 min-w-0 shrink bg-linear-to-r from-transparent to-[#F8494D]/70" />
      <span className="flex min-w-0 items-center justify-center gap-3">
        {number && <span className="shrink-0 bg-linear-to-r from-[#F8494D] to-[#FCAD66] bg-clip-text text-transparent">{number}</span>}
        <span>{label}</span>
      </span>
      <span aria-hidden="true" className="h-px w-24 min-w-0 shrink bg-linear-to-l from-transparent to-[#FCAD66]/70" />
    </div>
  );
}
